import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface ResponsiveTableShellProps {
  /** Card list rendered below the `md` breakpoint. */
  cards: ReactNode;
  /** Table rendered at and above the `md` breakpoint. */
  table: ReactNode;
  className?: string;
}

/**
 * Presentational switch that swaps a desktop `<Table>` for a mobile/tablet
 * card list at the Tailwind `md` breakpoint (≥768px).
 *
 * Both children render the same underlying dataset — the parent is
 * responsible for passing identical row data into `cards` and `table`.
 */
export function ResponsiveTableShell({
  cards,
  table,
  className,
}: ResponsiveTableShellProps) {
  return (
    <div className={className}>
      <div className="md:hidden h-full overflow-auto">{cards}</div>
      <div className={cn("hidden md:flex md:flex-col md:flex-1 md:min-h-0")}>{table}</div>
    </div>
  );
}